import { useQuery } from "react-query";
import { getDataStaffCourseRequests } from "~/pages/Editor/EditorStaff/requests/GetDataStaffCourseRequests/getDataExpectations";

export default function useGetStaffCourseExpectations(params: string) {
  return useQuery({
    queryKey: ["getDataStaffCourseRequests", params],
    queryFn: async () => {
      if (!params) return { courses: [] };

      const data = await getDataStaffCourseRequests(params);
      return Array.isArray(data) ? { courses: data } : data;
    },
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
}
